import { render } from "./AppDepositNftModal.vue?vue&type=template&id=c47c7fdc&scoped=true"
import script from "./AppDepositNftModal.vue?vue&type=script&lang=js"
export * from "./AppDepositNftModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/depositNftModal.scss?vue&type=style&index=0&id=c47c7fdc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c47c7fdc"]])

export default __exports__